import { forwardRef, type ButtonHTMLAttributes } from "react";

import styles from "./chip.module.css";
import { cx } from "./cx";

type Tone = "neutral" | "flag" | "risk";
type Size = "sm" | "md";

export interface ChipProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "children"
> {
  selected?: boolean;
  tone?: Tone;
  size?: Size;
  children: React.ReactNode;
}

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  (
    { className, selected = false, tone, size = "md", children, ...props },
    ref,
  ) => {
    const cls = cx(
      styles.chip,
      size === "sm" && styles.sm,
      tone && styles[tone],
      className,
    );

    return (
      <button
        ref={ref}
        type="button"
        data-selected={selected ? "true" : undefined}
        className={cls}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Chip.displayName = "Chip";
